// extracted by mini-css-extract-plugin
module.exports = {"labels":"ApplicationLabels_labels__1uTpn"};